import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Block } from './Block';
import { computeBlockColor } from './colorUtils';

interface BlockLineProps {
  blocks: number;
  color: string;
  label?: string;
  index?: number;
  onAdd?: () => void;
  onRemove?: () => void;
  hideRemove?: boolean; // Whether to hide the remove button
  interactive?: boolean;
}

export const BlockLine = React.forwardRef<HTMLDivElement, BlockLineProps>(
  ({ blocks, color, label, index = 0, onAdd, onRemove, hideRemove = false, interactive = true }, ref) => {
    // Compute the effective color based on the label
    // If label contains a color word, use that color; otherwise use the default color
    const { color: effectiveColor, isLight } = computeBlockColor(label, color);

    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3, ease: 'easeOut', delay: index * 0.1 }}
        className="tw-flex tw-gap-2"
      >
        <AnimatePresence mode="popLayout">
          {Array.from({ length: blocks }, (_, i) => (
            <Block
              key={i}
              color={effectiveColor}
              isLight={isLight}
              index={i}
              isFirst={i === 0}
              isLast={i === blocks - 1}
              onAdd={i === blocks - 1 ? onAdd : undefined}
              onRemove={i === 0 ? onRemove : undefined}
              hideRemove={hideRemove}
              interactive={interactive}
            />
          ))}
        </AnimatePresence>
      </motion.div>
    );
  },
);

BlockLine.displayName = 'BlockLine';
